import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Cases from "../pages/cases/page";
import CaseDetail from "../pages/case-detail/page";
import Guide from "../pages/guide/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/cases/:slug",
    element: <CaseDetail />,
  },
  {
    path: "/guide",
    element: <Guide />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;